import { c as _c } from "react/compiler-runtime";
import { formatTimestampToMonthYear } from "@/helpers/Helpers";
export default function UserPageHeaderProfileEnabledAt(t0) {
  const $ = _c(4);
  const {
    profileEnabledAt
  } = t0;
  if (!profileEnabledAt) {
    return null;
  }
  let t1;
  if ($[0] !== profileEnabledAt) {
    t1 = formatTimestampToMonthYear(new Date(profileEnabledAt).getTime());
    $[0] = profileEnabledAt;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="tw-mt-2"><p className="tw-mb-0 tw-text-iron-400 tw-text-sm tw-font-normal" suppressHydrationWarning={true}>Profile Enabled:{" "}{t1}</p></div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}